/* 
 	* 指令下发组件 
 	* 描述：InsGT740VibrationAlarmSet指令下发
 	* 创建时间：2017-07-27 
 	* 创建人：baixx 
*/
<template>
	<div>
		<form class="form-horizontal pt10px">
			<div class="form-group">
				<label class="col-sm-3 control-label">报警开关</label>
				<div class="col-sm-6 form-control-static pb0px">
					<label class=" pr20px">
						<radio v-model="alarmSwitch" true-value="ON">开</radio>
					</label>
					<label class="">
						<radio v-model="alarmSwitch" true-value="OFF">关</radio>
					</label>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-3 control-label">上报模式</label>
			    <div class="col-sm-6">
			        <select class="form-control" :disabled="this.alarmSwitch == 'OFF'" v-model="reportMode">
						<option value="0">仅GPRS</option>
						<option value="1">SMS+GPRS</option>
						<option value="2">GPRS+SMS+CALL</option>
					</select>
			    </div>
		   </div>
		   <div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px pr10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div> 
		</form>
   </div>	
</template>
<script>
    import Radio from 'components/common/Radio' 
	export default {
		name: "InsGT740VibrationAlarmSet",
		components: {
    	    Radio
        },
		data() {
			return {
				alarmSwitch:"ON",                //报警开关
				reportMode:"",                  //上报模式
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			},
			alarmSwitch(val){
				this.alertMsg = ''
				this.reportMode = ''
			},
			reportMode(val){
				this.alertMsg = ''
			}
		},
		methods: {	
			resetInput(){
				this.alarmSwitch = 'ON'
				this.reportMode = ''
				this.alertMsg = ''
				
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				let arr = []
				/*if(this.alarmSwitch == ""){
					this.alertMsg = "请先选择报警开关";
					return;
				}*/
				if(this.alarmSwitch == 'ON'){ 
					if(this.reportMode=='' || this.reportMode == undefined){
						this.alertMsg = "请选择上报方式"
						return
					}else{
						this.alertMsg = '' 
						arr = ["SETPRM","SENALM",this.alarmSwitch,this.reportMode]
					}
				}else{
					this.alertMsg = '' 
					arr = ["SETPRM","SENALM",this.alarmSwitch]
				}   
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsGT740VibrationAlarmSet.vue?57081356